import { useState } from 'react';


const useScroll = () => {
  const [isScrollLeft, setScrollLeft] = useState(false);
  const [isScrollRight, setScrollRight] = useState(true);
  const onScroll = (event) => {
    const {scrollLeft, scrollWidth, offsetWidth} = event.target;
    setScrollLeft(scrollLeft !== 0  || scrollLeft);
    setScrollRight((scrollLeft === 0  || scrollLeft !== (scrollWidth - offsetWidth)));
  };
  return [isScrollLeft, isScrollRight, { onScroll }];
};

export default useScroll;
